import { AnalyticsNames } from '../models/analytics-names';
import { Entity } from '../models/entity';
import { sendEvent } from '../store/analytics';
import { read } from '../store/good-cop';

export async function failPositiveEngagement(params: {
  entity: Entity;
  id: string;
}): Promise<void> {
  const startParams = await read();
  const totalParams = {
    ...startParams,
    ...params,
  };
  sendEvent(AnalyticsNames.PositiveEngagementFailed, totalParams);
}
